<template>
  <div class="content">
    <div class="set_wrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <el-form-item label="售后期限" prop="day">
          <el-input v-model.number="formdata.day" class="w80"></el-input>&nbsp;&nbsp;天
          <p class="prompt_infor">温馨提示：设置商品付款后几天内可发起退款、退货退款，超过设定天数后买家将无法发起售后</p>
        </el-form-item>
        <!-- <div class="addr_row">
          <div class="addr_title">商品退回设置</div>
          <div class="addr_wrap">
            <div class="addr_item" v-for="(addressitem,index) in formdata.addresslist" :key="index">
              <el-form-item
                label="退回联系人"
                :prop="'addresslist.' + index + '.contact'"
                :rules="{
                  required: true, message: '请输入联系人', trigger: 'blur'
                }"
              >
                <el-input v-model="addressitem.contact" placeholder="请填写商品退回时的收货联系人"></el-input>
              </el-form-item>
              <el-form-item
                label="联系人手机"
                :prop="'addresslist.' + index + '.phone'"
                :rules="{
                  required: true, message: '请输入联系人手机', trigger: 'blur'
                }"
              >
                <el-input v-model="addressitem.phone" placeholder="请填写商品退回时的收货人电话"></el-input>
              </el-form-item>
              <el-form-item label="商品退回地址" required>
                <el-col :span="8">
                  <el-form-item
                    :prop="'addresslist.' + index + '.province'"
                    :rules="{
                      required: true, message: '请选择省', trigger: 'change'
                    }"
                  >
                    <el-select
                      v-model="addressitem.province"
                      placeholder="请选择"
                      @change="changeprovince(addressitem.province,addressitem)"
                    >
                      <el-option
                        v-for="item in provinceoptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :prop="'addresslist.' + index + '.city'"
                    :rules="{
                      required: true, message: '请选择市', trigger: 'change'
                    }"
                  >
                    <el-select
                      v-model="addressitem.city"
                      placeholder="请选择"
                      @change="changecity(addressitem.city,addressitem)"
                    >
                      <el-option
                        v-for="item in addressitem.cityoptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :prop="'addresslist.' + index + '.district'"
                    :rules="{
                      required: true, message: '请选择区', trigger: 'change'
                    }"
                  >
                    <el-select v-model="addressitem.district" placeholder="请选择">
                      <el-option
                        v-for="item in addressitem.districtoptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24" class="mt20">
                  <el-form-item
                    :prop="'addresslist.' + index + '.address'"
                    :rules="{
                      required: true, message: '请输入地址', trigger: 'blur'
                    }"
                  >
                    <el-input v-model="addressitem.address" placeholder="请输入详细地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item>
                <el-button @click="deladdress(index)">删除</el-button>
              </el-form-item>
            </div>
            <div class="addr_add">
              <el-button @click="addaddress">新增回退地址</el-button>
            </div>
          </div>
        </div> -->

        <el-form-item class="mt20">
          <el-button type="primary" @click="save('form')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
export default {
  name: "aftersalesSettings",
  data() {
    return {
      formdata: {
        day: "",
        addresslist: [
          {
            contact: "",
            phone: "",
            province: 2,
            city: "",
            district: "",
            address: "",
            cityoptions: [],
            districtoptions: []
          }
        ]
      },
      provinceoptions: [],

      rules: {
        day: [{ required: true, message: "请输入售后期限", trigger: "blur" }]
      }
    };
  },
  created() {
    this.queryconfigsale();
    this.queryprovinceoptions();
  },
  methods: {
    // 查询售后设置
    queryconfigsale() {
      let params = {};
      this.axios
        .post(api.shopconf_sale, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.day = response.data.info.day;
            this.formdata.addresslist = this.translateaddress(
              response.data.list
            );
          } else {
          }
        })
        .catch(() => {});
    },
    // 转换地址
    translateaddress(addrlist) {
      let res = [];
      if (addrlist && addrlist.length > 0) {
        addrlist.forEach(async item => {
          let addrobj = {
            id: item.id,
            contact: item.contact,
            phone: item.phone,
            province: parseInt(item.province),
            city: parseInt(item.city),
            district: parseInt(item.district),
            address: item.address
          };
          let cityres = await this.querycity(item.province);
          if (cityres && cityres.data.code == 0) {
            addrobj.cityoptions = cityres.data.list || [];
          }
          let districtres = await this.querydistrict(item.city);
          if (districtres && districtres.data.code == 0) {
            addrobj.districtoptions = districtres.data.list || [];
          }

          res.push(addrobj);
        });
      }

      return res;
    },
    // 查询市
    querycity(val) {
      let params = {
        parent_id: val,
        type: 1
      };
      return this.axios.post(api.shopconf_get_address, params);
    },
    // 查询区
    querydistrict(val) {
      let params = {
        parent_id: val,
        type: 2
      };
      return this.axios.post(api.shopconf_get_address, params);
    },
    // 查询省
    queryprovinceoptions() {
      let params = {
        parent_id: "",
        type: 0
      };
      this.axios
        .post(api.shopconf_get_address, params)
        .then(response => {
          if (response.data.code == 0) {
            this.provinceoptions = response.data.list || [];
          } else {
          }
        })
        .catch(() => {});
    },
    // 切换省
    async changeprovince(val, item) {
      item.city = "";
      item.district = "";
      item.cityoptions = [];
      item.districtoptions = [];
      let cityres = await this.querycity(val);
      if (cityres && cityres.data.code == 0) {
        item.cityoptions = cityres.data.list || [];
      }
    },

    // 切换市
    async changecity(val, item) {
      item.district = "";
      item.districtoptions = [];
      let districtres = await this.querydistrict(val);
      if (districtres && districtres.data.code == 0) {
        item.districtoptions = districtres.data.list || [];
      }
    },

    // 新增地址
    addaddress() {
      this.formdata.addresslist.push({
        contact: "",
        phone: "",
        province: "",
        city: "",
        district: "",
        address: "",
        cityoptions: [],
        districtoptions: []
      });
    },
    //  删除地址
    deladdress(index) {
      this.formdata.addresslist.splice(index, 1);
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 获取提交参数
    getaddressparams() {
      let res = [];
      if (this.formdata.addresslist && this.formdata.addresslist.length) {
        this.formdata.addresslist.forEach(item => {
          let addritem = {
            contact: item.contact,
            phone: item.phone,
            province: item.province,
            city: item.city,
            district: item.district,
            address: item.address
          };
          if (item.id !== undefined) {
            addritem.id = item.id;
          }
          res.push(addritem);
        });
      }
      return res;
    },
    // 提交保存
    submitsave() {
      let params = {
        day: this.formdata.day,
        return_address: this.getaddressparams()
      };
      this.axios
        .post(api.shopconf_sale_edit, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.set_wrap{-webkit-box-shadow: none; box-shadow: none;}
</style>